import type { Movie } from "@/types/content";
import MovieCard from "@/components/feature/MovieCard";

interface LatestSectionProps {
  movies: Movie[];
}

export default function LatestSection({ movies }: LatestSectionProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} />
      ))}
    </div>
  );
}